import m from "../../geodata/es2015/congoHigh";
window.am4geodata_congoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/congoHigh.js
// module id = null
// module chunks = 